import React from "react";

const AnimalWelfare = () => {
  return (
    <div className="m-[50px] text-center font-medium text-[20px]">
      Animal Welfare Indices are coming soon!
    </div>
  );
};

export default AnimalWelfare;
